import React, { useRef, useState, useEffect } from "react";
import { categoryTabs } from "../data/mockData";

const CategoryTabs = ({ activeTab, setActiveTab }) => {
  const tabRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  useEffect(() => {
    const activeIndex = categoryTabs.findIndex((t) => t.label === activeTab);
    const el = tabRefs.current[activeIndex];
    if (el) {
      setIndicatorStyle({ left: el.offsetLeft, width: el.offsetWidth });
    }
  }, [activeTab]);

  return (
    <div className="relative w-fit border-b border-white border-opacity-30">
      <div className="flex flex-wrap gap-0" role="tablist" aria-label="Property category tabs">
        {categoryTabs.map((tab, i) => (
          <button
            key={tab.label}
            ref={(el) => (tabRefs.current[i] = el)}
            role="tab"
            aria-selected={activeTab === tab.label}
            onClick={() => setActiveTab(tab.label)}
            className={`mr-10 pb-3 text-sm transition-colors duration-150 focus:outline-none whitespace-nowrap ${
              activeTab === tab.label
                ? "text-white font-bold"
                : "text-white font-normal opacity-80 hover:opacity-100"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* sliding indicator */}
      <span
        className="absolute bottom-0 h-0.5 bg-white rounded-full transition-all duration-300 ease-in-out"
        style={{ left: indicatorStyle.left, width: indicatorStyle.width }}
        aria-hidden="true"
      />
    </div>
  );
};

export default CategoryTabs;
